<template>
    <div class="home">
        <div class="inner">
            <div class="story-label text-uppercase"><span class="text-blueGray">3D-Interaktiv</span></div>
            <div class="block my-auto">
                <div class="story-headline"><span class="text-blueGray">Tschernobyl-<br>Katastrophe in 3D</span></div><br><font size="4"></font>
                <div class="keyline-cnt position-relative my-1 py-1">
                    <div class="keyline"></div>
                </div>
                <div class="story-subline"><font size="5"><span class="text-blueGray">34 Jahre nach dem <br><strong>Super-GAU</strong></span>  </font></div>
            </div>
            <div class="block my-auto">
                <div class="d-flex justify-content-center">
                    <div class="visible-babylon-loading">
                        <div class="cta">
                            <img class="img-fluid" src="../BabylonStory/assets/img/anim_cube_loading-tiny.png" alt="">
                            <span class="loading-message">lade...</span>
                        </div>
                    </div>
                    <div class="hidden-babylon-loading">
                        <div class="cta">
                            <button class="btn btn--start" v-on-single-click="next">
                                <img class="icon" src="../BabylonStory/assets/img/arrow-next-lg.svg" alt="">
                                <img class="help-text help-text--start" src="../BabylonStory/assets/img/start_landscape_handschrift_anim.png" alt="">

                                <!-- TODO: fallback APNG -->

                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="logo">
                <img class="img-fluid" src="../BabylonStory/assets/img/ui_zdf_heute_logo_002_aw.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {
            moveCamera: [-8.9, 1.25,10,12,.5,0],

            Geo_Tschernobyl: {
                children: {

                BG_Sphere: false,

                Geo_Neuer_Sarkophag_endpos: true,
                Geo_Schattenplane_NSC: true,


                Geo_Textur1_Reaktor_4_Damage: false,
                Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                Geo_Textur1_Reaktor_4_Damage_Innen: false,

                Geo_Beton_Sarkophag_Rost: true,
                Geo_Schattenplane_Betonsarkophag: true,

                Geo_GrosserTurm_Gestaenge1: false,
                Geo_GrosserTurm_Schlot1: false,
                Geo_GrosserTurm_RoteStreifen1: false,
                Geo_GrosserTurm_Schattenplane: false,

                Geo_KleinerTurm_Geruest1: true,
                Geo_KleinerTurm_RoteStreifen1: true,
                Geo_KleinerTurm_Schlot1: true,
                Geo_KleinerTurm_Schattenplane: true,
                    
                },
            },


        },
        babylonReady: function ()
        {
            this.$babylonController.zoomCamera(1.65);

            this.$audioController.initTrack('background', require('./../assets/audio/Geigerzaehler.mp3'), true, false);


            //this.$babylonController.setCamera(Math.PI/2, Math.PI/2, 20);
            this.$babylonController.createDebugger();
        },
        methods: {
            next: function () {
                this.$tracking.navigationClick('Start');
                this.$eventBus.$emit('nextPage');
            }
        },
        

    }
</script>


<style scoped lang="scss">

    @import "../BabylonStory/assets/scss/variables";
    @import "../BabylonStory/assets/scss/functions";
    @import "../BabylonStory/assets/scss/mixins";

    .block {

        padding: 0 gridColumnsToRem(3);

        @media (orientation: landscape) {
            margin-left: calc( 50% + #{gridColumnsToRem(3)} );
            margin-left: 50%;
        }
    }

    .cta {
        position: relative;
        width: 120px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        @media (orientation: landscape) {
            width: 5rem;
            height: 5rem;
        }
    }
    .loading-message {
        position: absolute;
        bottom: 0;
        width: 100%;
        text-align: center;
        font-size: 1.2rem;
        @include fontFamily(Thin);
    }

    .home::before {
        content: '';
        position: absolute;
        top: gridColumnsToRem(-6);
        bottom: gridColumnsToRem(-6);
        width: 100%;

        background-color: $warm-gray; //HENRIK blue-gray

        $gradient: linear-gradient(rgba($warm-gray, .6)); //HENRIK blue-gray   //.65

        background-image: $gradient, url("../BabylonStory/assets/img/Titelbild_Tschernobyl.jpg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;

        @media (orientation: landscape) {

            background-image: $gradient, url("../BabylonStory/assets/img/Titelbild_Tschernobyl_landscape.jpg");
            //background-position: left bottom;
            background-position: left 25% bottom;
        }
    }

    .inner {

        position: absolute;
        top: gridColumnsToRem(3);
        bottom: 0;
        width: 100%;

        display: flex;
        flex-direction: column;

        overflow: auto;
        @supports (-webkit-overflow-scrolling: touch) {
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
        }

        @media (orientation: landscape) {
            top: 0;
        }
    }


    .home {

        color: $white;
        pointer-events: auto;
        user-select: none;

        .story-label {
            @include fontFamily(Black);
            font-size: psdPxToRem(36);
        }
        .story-headline {
            @include fontFamily(Bold);
            font-size: psdPxToRem(140);
        }
        .story-subline {
            @include fontFamily(Roman);
            font-size: psdPxToRem(110);
        }

        .logo {

            width: psdPxToRem(216);
            height: gridColumnsToRem(5);

            margin-left: gridColumnsToRem(3);
            display: flex;
            align-items: center;
        }
        .story-label {

            margin: 0 gridColumnsToRem(3);
        }
        .story-headline {

        }

        .keyline-cnt {

            margin-left: -(gridColumnsToRem(3));
            .keyline {
                //width: gridColumnsToRem(6);
            }

        }

        @media (orientation: landscape) {

            .story-label,
            .logo {
                position: absolute;
            }
            .story-label {
                margin-top: 3rem;
            }
            .logo {
                bottom: 0;
            }
        }

    }


</style>